import { Fragment } from 'react'

import { FloatingTooltip } from '../../Floating'
import { Status } from '../../Status'

import * as styles from './MessageStatuses.module.css'

function MessageStatuses({ className, statuses }) {
  return statuses.map(status => (
    <Fragment key={status.id}>
      <FloatingTooltip content={status.tooltip}>
        <div className={styles.status}>
          <Status
            className={className}
            text={status.text}
            textColor={status.textColor}
          />
        </div>
      </FloatingTooltip>
    </Fragment>
  ))
}

export default MessageStatuses
